import { render, staticRenderFns } from "./RegionIntent.vue?vue&type=template&id=6ad1360b&scoped=true"
import script from "./RegionIntent.vue?vue&type=script&lang=js"
export * from "./RegionIntent.vue?vue&type=script&lang=js"
import style0 from "./RegionIntent.vue?vue&type=style&index=0&id=6ad1360b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad1360b",
  null
  
)

export default component.exports